import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GivelifyIcon, GivelifyLoading } from '@givelify/givelify-ui';
import { styled } from '@mui/material';

export const ReportLinkWrapper = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    height: 24,
    color: theme.palette.primary.main,
    '& svg': {
        width: 24,
        height: 24,
        marginRight: 0,
    },
}));

export const Loader = styled(GivelifyLoading)(({ theme }) => ({
    width: '16px !important',
    height: '16px !important',
    '& svg': {
        width: 16,
        height: 16,
    },
    margin: '0 4px !important',
}));

export const IconWithLabel = styled(GivelifyIcon)({
    marginRight: '2px !important',
});

export const ErrorIcon = styled(IconWithLabel)(({ theme }) => ({
    color: theme.legacy.palette.error.main,
}));

export const WaitIcon = styled(FontAwesomeIcon)(({ theme }) => ({
    width: '14px !important',
    height: '14px !important',
    margin: '0 5px !important',
}));
